"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListenerItem = void 0;
var debounce_1 = require("../debounce");
var ListenerItem = /** @class */ (function () {
    function ListenerItem(element, callback, event, debounceValue, filter, once) {
        this.element = element;
        this.originalCallback = callback;
        this.eventName = event;
        this.debounceValue = debounceValue;
        this.filter = filter;
        this.once = once;
        this.callback = this.createCallback();
    }
    ListenerItem.prototype.subscribe = function () {
        this.stopped = false;
        this.element.addEventListener(this.eventName, this.callback);
    };
    ListenerItem.prototype.unsubscribe = function () {
        this.element.removeEventListener(this.eventName, this.callback);
        this.stopped = true;
    };
    ListenerItem.prototype.createCallback = function () {
        var _this = this;
        var listener = function (event) {
            if (typeof _this.filter === 'function' && !_this.filter(event, _this.eventName)) {
                return;
            }
            _this.originalCallback(event, _this.eventName);
            if (_this.once) {
                _this.unsubscribe();
            }
        };
        return typeof this.debounceValue === 'number' ? debounce_1.debounce(listener, this.debounceValue) : listener;
    };
    return ListenerItem;
}());
exports.ListenerItem = ListenerItem;
//# sourceMappingURL=listener-item.js.map